/*
 * Helpers to handle zod form validation where native input
 * needs to be transformed before validation
 * */
import { z, ZodAny, ZodDate, ZodNumber, ZodString } from "zod";

export const zStringToDate = (validator: ZodDate = z.date()) =>
  z.preprocess(arg => {
    if (typeof arg == "string" || arg instanceof Date) return new Date(arg);
  }, validator);

export const zStringToNumber = (validator: ZodNumber = z.number()) =>
  z.preprocess(arg => parseInt(`${arg}`, 10), validator);

export const zStringToJson = (validator: ZodAny = z.any()) =>
  z.preprocess(arg => {
    if (typeof arg === "string") {
      try {
        return JSON.parse(arg);
      } catch {
        return arg;
      }
    }
    return arg;
  }, validator);

export const zJsonToString = (validator: ZodString = z.string()) =>
  z.preprocess(arg => {
    if (typeof arg !== "string") {
      try {
        return JSON.stringify(arg);
      } catch {
        return arg;
      }
    }
    return arg;
  }, validator);
